export function never(o: never): never {
  throw new Error('The typescript compiler should make sure this method is never called');
}
